import { createContext, useState } from "react";

export const AppRefreshContext = createContext();

export const AppRefreshProvider = ({ children }) => {
  const [appKey, setAppKey] = useState(0);

  const refreshApp = () => {
    setAppKey(prev => prev + 1);
  };

  return (
    <AppRefreshContext.Provider value={{ appKey, refreshApp }}>
      {children}
    </AppRefreshContext.Provider>
  );
};